import {BloodGridActions} from "../redux_constants/bloodGrid.constant"

const InitialState = {
    class: 'WBC',
    tag: '',
    selected: false,
    selected_anno: '',
    move: false,
    update_list: false,
    summary_data: [],
    page_size: '',
    page: 1,
}

export const bloodGridReducer = (state = InitialState, action) => {
    switch (action.type) {
        case BloodGridActions.BLOOD_FILTER_DEFAULT:
            return Object.assign({}, state, {
                class: 'WBC',
                tag: '',
            })

        case BloodGridActions.BLOOD_CLASS_CHANGED:
            return Object.assign({}, state, {
                class: action.response,
                tag: ''
            })

        case BloodGridActions.BLOOD_ANNO_STOP_MOVE:
            return Object.assign({}, state, {
                move: false,
            })

        case BloodGridActions.BLOOD_ANNO_UPDATE_SUMMARY:
            return Object.assign({}, state, {
                update_list: action.response
            })

        case BloodGridActions.UPDATE_PAGE:
            return Object.assign({}, state, {
                page: action.response,
            })

        default :
            return state
    }
}